import { useContext } from "react"
import TextEditorContext from "../context/TextEditorContext";

const useTextEditorContext = () => {
    return useContext(TextEditorContext);
}

export default useTextEditorContext;